import { useLoader } from '@react-three/fiber';
import React from 'react';
import { Color, Euler, TextureLoader } from 'three';
import { CircleShape } from './circle-shape';
import { TextThreeRendering } from './text-maker';
var RobotImageMaker = function (_a) {
    var imageUrl = _a.imageUrl, position = _a.position, rotation = _a.rotation, onRobotClick = _a.onRobotClick, robot = _a.robot;
    var alphaTestThreshold = 0.5;
    var texture = useLoader(TextureLoader, imageUrl, undefined, function (err) {
        console.error("Error loading image from ".concat(imageUrl, ":"), err);
    });
    if (!texture) {
        console.error("Failed to create image texture with ".concat(robot.iconPath, "."));
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("mesh", { position: position, rotation: new Euler(0, 0, rotation.z), onClick: function (ev) { return onRobotClick && onRobotClick(ev, robot); } },
            React.createElement("planeGeometry", { attach: "geometry", args: [texture.image.width * robot.scale, texture.image.height * robot.scale] }),
            React.createElement("meshBasicMaterial", { attach: "material", map: texture, color: new Color(robot.color), alphaTest: alphaTestThreshold, toneMapped: false }))));
};
export var RobotThreeMaker = function (_a) {
    var imageUrl = _a.imageUrl, robot = _a.robot, position = _a.position, onRobotClick = _a.onRobotClick, rotation = _a.rotation, circleSegment = _a.circleSegment;
    return (React.createElement(React.Fragment, null,
        React.createElement(TextThreeRendering, { position: [position.x, position.y, position.z + 1], text: robot.name }),
        imageUrl ? (React.createElement(RobotImageMaker, { imageUrl: imageUrl, position: position, rotation: rotation, onRobotClick: function (ev) { return onRobotClick && onRobotClick(ev, robot); }, robot: robot })) : (React.createElement(CircleShape, { position: position, rotation: rotation, onRobotClick: function (ev) { return onRobotClick && onRobotClick(ev, robot); }, robot: robot, segment: circleSegment }))));
};
